import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaComments, FaBookOpen, FaBook, FaBrain, FaMap } from 'react-icons/fa';

const BottomNavigation: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-base-200 border-t border-base-300 z-50 safe-area-bottom">
      <nav className="flex justify-around items-center h-16 max-w-screen-xl mx-auto">
        {/* Conversations */}
        <button
          onClick={() => navigate('/conversations')}
          className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
            isActive('/conversations')
              ? 'text-primary'
              : 'text-base-content/60 hover:text-base-content'
          }`}
        >
          <FaComments size={24} />
          <span className="text-xs mt-1">{t('navigation.chat')}</span>
        </button>

        {/* Learn (Curriculum) */}
        <button
          onClick={() => navigate('/learn')}
          className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
            isActive('/learn')
              ? 'text-primary'
              : 'text-base-content/60 hover:text-base-content'
          }`}
        >
          <FaMap size={24} />
          <span className="text-xs mt-1">{t('navigation.learn') || 'Learn'}</span>
        </button>

        {/* Grammar Practice */}
        <button
          onClick={() => navigate('/grammar')}
          className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
            isActive('/grammar')
              ? 'text-primary'
              : 'text-base-content/60 hover:text-base-content'
          }`}
        >
          <FaBookOpen size={24} />
          <span className="text-xs mt-1">{t('navigation.grammar')}</span>
        </button>

        {/* Reviews */}
        <button
          onClick={() => navigate('/review')}
          className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
            isActive('/review')
              ? 'text-primary'
              : 'text-base-content/60 hover:text-base-content'
          }`}
        >
          <FaBrain size={24} />
          <span className="text-xs mt-1">{t('navigation.review')}</span>
        </button>

        {/* Dictionary */}
        <button
          onClick={() => navigate('/dictionary')}
          className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
            isActive('/dictionary')
              ? 'text-primary'
              : 'text-base-content/60 hover:text-base-content'
          }`}
        >
          <FaBook size={24} />
          <span className="text-xs mt-1">{t('navigation.dictionary')}</span>
        </button>
      </nav>
    </div>
  );
};

export default BottomNavigation;
